import { render, staticRenderFns } from "./GuessLike.vue?vue&type=template&id=5d0d2ab1&scoped=true&"
import script from "./GuessLike.vue?vue&type=script&lang=js&"
export * from "./GuessLike.vue?vue&type=script&lang=js&"
import style0 from "./GuessLike.vue?vue&type=style&index=0&id=5d0d2ab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d2ab1",
  null
  
)

export default component.exports